// 生成token 

import { useEffect, useState } from "react"
import { autoCreateUserAuth, dwgToOcf, apiUrl } from "../../api/autoCad";
import { getCookie,  } from "../../util/utils";
require('./GStarSDK')
const lookFun = (id, url) => {
    // const url = id;
    // const url = `https://oss-panzi-app-prod.panzitech.com/_5576_1693449590080_1693449588189bfcb1831-0bce-47ad-8d82-f82e145e4d90.ocf`
    // 下载图纸数据
    function getDrawSheet(url, cb) {
        let req
        if (window.XMLHttpRequest) {
            req = new XMLHttpRequest()
        } else {
            //让eslint 忽视文件
            /* eslint-disable */
            req = new ActiveXObject('Microsoft.XMLHTTP')
            /* eslint-enable */
        }
        gstarSDK.Tips.showProgress(0, '下载中...')
        req.onload = function () {
            if ((req.status >= 200 && req.status < 300) || req.status === 304) {
                cb(req.response)
            }
            if (req.status === 404) {
                cb('未找到对应文件')
            }
        }
        req.open('GET', url, true)
        req.responseType = 'arraybuffer'
        req.send(null)
    }

    function showcad(ocfurl) {
        var secret = 'fldXImCGIwhP8ZQO4qecFY4ir2JxCc8bQUQ1ORrusA70H26qenVFScQPm3tMVFJ5'
        gstarSDK.setDynamicPW(secret)  //授权验证

        // console.time("解析ocf共计用时：")
        getDrawSheet(ocfurl, function (arraybuffer) {
            gstarSDK.render('ocf', arraybuffer, '111', true).then(() => {
                // console.log('图纸渲染显示完成')//此处可以添加需要加载完ocf以后才能进行的操作，例如加载批注
                // console.timeEnd("解析ocf共计用时：")
            })
        })

    }

    // 切换布局回调方法
    function switchLayout(obj) {
     
        const cad_token = getCookie('cad_token') 
        //根据布局globalName获取相应布局名称，由于布局图形必须有对应的布局名称，后台才能转换生成，需要将布局名传给后台，然后后台返回转换后的ocf地址
        var makeocfurl = apiUrl + '/api/cad/convert/toOcfUrl?fileId=' + fileId + '&layout=' + obj.globalName + '&layoutName='
            + obj.nickName + '&file=' + url + "&token=" + cad_token
        let layoutocfurl = getLayoutOcfUrl(makeocfurl)
        // let layoutocfurl = demoocfurl[String(obj.globalName)] //样例布局ocf文件
        if (layoutocfurl === "") {
            //布局转换失败后加载源文件
            layoutocfurl = defaultocfurl;
        }
        showcad(layoutocfurl)
        // getDrawSheet(layoutocfurl, function (arraybuffer) {
        //   gstarSDK.render('ocf', arraybuffer, fileId, false)
        // })
    }

    const hideFunction = {
        // save: [ // 保存
        //   'saveAs', // 另存为
        //   'savePDF', // 另存PDF
        //   'saveImg', // 截图
        //   'print', // 打印
        // ],
        // measures: [ // 测量
        //   'measureLength', // 长度
        //   'measureArea', // 面积
        //   'measureCoordinate', // 坐标
        //   'measureArc', // 弧长
        //   'measureAngle', // 角度
        //   'measureSetProportion',// 设比例
        // ],
        // viewport: [ // 视口相关
        //   'zoomE', // 显示全图
        //   'custom', // 窗口缩放
        //   'fullScreen', // 全屏
        //   'switchBackground'//切换背景色
        // ],
        notes: [ // 标注
            'noteCustomizeLine',
            'noteArrow',
            'noteWord',
            'noteCloudLine',
            'noteImage',
            'noteGuideLine',
            'noteStraightLine',
            'noteRectangle',
            'noteOval',
            'noteCheckView',
            'noteStamp'
        ]
    }
    // 初始化SDK
    /*eslint-disable*/
    let gstarSDK = new GStarSDK({
        wrapId: id,  //容器ID
        // switchLayoutCB: switchLayout, // 点击布局功能会触发此回调
        // switchLayoutCB: switchLayout, // 点击布局功能会触发此回调
        apiHost: window.location.host,  //API域名，转换PDF、另存功能需要向该域名发送请求，如果没有用的转PDF、版本转换功能，则无须关注这个参数。
        isHideMarks: true,//是否隐藏软件自带的书签功能
        tipsTime: 3000, //错误提示信息存在时间(毫秒)，默认3000（3秒）
        mobileSizeLimit: 5242880, //移动端可打开ocf文件的最大限制（字节数），默认5242880(5M)
        pcSizeLimit: 10582912,  //PC端可打开ocf文件最大限制（字节数），默认12582912(12M)
        sizeLimitCB: sizeLimit, //当ocf文件超过设置的最大值后，执行该回调函数
        language: 'zh', //语言设置，可选'zh'（简中）/'en'(英语)/'ko'(韩语),默认'zh'
        measureAccuracy: 3,  //测量数值的精度位数
        mode: 'default', //填充显示模式，"default":默认值，粗文字不填充，其他填充图案正常填充；"line":所有元素都不填充；"fill":所有需要填充元素都填充
        toolbarHideItems: hideFunction, // 隐藏hideFunction里面的功能
    })

    gstarSDK.enableZoom()  // 开启鼠标缩放功能
    gstarSDK.enablePan()    // 开启鼠标平移功能
    // 布局切换事件，点击页面右上方布局按钮，切换显示布局对应的ocf文件
    gstarSDK.on('changeLayout', (eventName, obj) => {
        //obj.globalName是布局名称，根据这个布局名，从json数据里面得到对应ocf图纸链接
        //如果后端将所有布局对应的ocf文件链接都返回了，就可以直接加载。如果只返回了默认布局的ocf，切换布局后需要参考下面注释掉的代码，向后端发送请求，等待后端返回当前切换布局的ocf文件链接。
        switchLayout(obj)
       
    })

    let fileId = 54238117 //当前图纸的唯一标识

    // 当ocf文件超过设置的最大值后，执行这个函数，里面逻辑可以自己定义
    function sizeLimit(ocfSize, limitSize) {
        alert('文件较大，不支持预览')
        //alert('图纸太大，当前图纸大小:' + parseInt(ocfSize / 1048576) + 'M,大于系统限制的：' + parseInt(limitSize / 1048576)+'M')
    }

    //测试用的ocf样例文件
    let demoocfurl = {
        '*MODEL_SPACE': url,
        // '*MODEL_SPACE': 'https://resource-cn.gstarcad.com/sampledraw/0000012863.ocf',

    }
    // 获取布局图纸转换请求链接返回的ocf地址
    function getLayoutOcfUrl(url) {
        let req
        if (window.XMLHttpRequest) {
            req = new XMLHttpRequest()
        } else {
            req = new ActiveXObject('Microsoft.XMLHTTP')
        }
        req.open('GET', url, false)
        req.send(null)

        req.onreadystatechange = function () {
            if (req.status == 200 && req.readyState == 4) {
                alert(req.responseText)
            }
        }
        return req.responseText
    }

    // 初始化渲染默认ocf文件
    //let defaultocfurl = 'http://127.0.0.1/file/ocf/1001/test.ocf'  //默认显示的ocf文件url地址
    let defaultocfurl = demoocfurl['*MODEL_SPACE']
    showcad(defaultocfurl)
    // getDrawSheet(defaultocfurl, function (arraybuffer) {
    //   gstarSDK.render('ocf', arraybuffer, fileId, true)
    // })

}
export default () => {
    const [token, setToken] = useState()
    useEffect(async () => {
        const token = await autoCreateUserAuth();
        setToken(token)
    }, [])

    const dwgToOcfApi = async (params) => {
        let returnObj;
        try {
            returnObj = await dwgToOcf(token, params)
        } catch (error) {
            const token = await autoCreateUserAuth(true);
            setToken(token)
            returnObj = await dwgToOcf(token, params);
        }
        // setloading(true)
        return returnObj

    }
    return {
        dwgToOcf: dwgToOcfApi, lookFun
    }
}